var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{staticClass:"datatable",attrs:{"responsive":"","bordered":"","small":"","items":_vm.modified,"fields":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }